import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useSelector } from "react-redux";
import { formatDate } from "../../../../../../../../utils/common";

const Training_Report_Table = ({
  setEdit,
  currentPage,
  setCurrentPage,
  personaldetails,
}) => {
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const perPage =
  personaldetails?.per_page || personaldetails?.data?.length || 0;

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Date</th>
                <th>Name</th>
                <th>Contact No.</th>
                <th>Email</th>
                <th>Type of Training</th>
                <th>Training Field</th>
                <th>Duration</th>
              </tr>
            </thead>

            <tbody>
              {personaldetails.data.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No data found
                  </td>
                </tr>
              ) : (
              personaldetails?.data?.map((row, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * perPage + index + 1}</td>
                  <td>{formatDate(row.createdAt)}</td>
                  <td>{row?.User?.name}</td>
                  <td>{row.User?.contact_no}</td>
                  <td>{row.User?.email}</td>
                  <td>{row.Type_Of_Training?.name}</td>
                  <td>{row.Training_Field?.name}</td>
                  <td>{row.duration}</td>
                </tr>
              ))
            )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {personaldetails?.data.length} of{" "}
            {personaldetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={personaldetails?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Training_Report_Table;
